import { ZoneState } from '@/__generated__/graphql';
import { useEffect, useRef } from 'react';
import { useAtomValue } from 'jotai';
import * as state from '@/state';
import { useIdleTimer } from './useIdleTimer';
import { useWorkFlowTimeAndStateUpdater } from './useUpdateWorkFlowTimeAndState';
import { useWorkflowStages } from './useWorkflowStages';

export function useTimeLogs() {
  const selectedZone = useAtomValue(state.selectedZone);
  const selectedZoneRef = useRef(selectedZone);
  const { updatedWorkflowTimeAndState } = useWorkFlowTimeAndStateUpdater();
  const { workflowUpdateHandler } = useWorkflowStages();

  const logTimeOfUser = async () => {
    const zone = selectedZoneRef.current;
    if (zone?.workflowStatus?.state === ZoneState.Start) {
      await workflowUpdateHandler(ZoneState.Pause);
      await updatedWorkflowTimeAndState({
        typeOfTimeLog: 'totalTime',
        pausedBy: 'SYSTEM',
      });
    }
  };

  useIdleTimer(() => {
    logTimeOfUser();
  }, 120000);

  useEffect(() => {
    selectedZoneRef.current = selectedZone;
  }, [selectedZone]);
}
